/* APOKTO-AVAILABILITY-V5: SINED + NOVATERM STOCK0 */
(() => {
  const triggerSelector = '[data-apk-availability-trigger]';
  const dialogSelector = '[data-apk-availability-dialog]';

  const getDialog = () => document.querySelector(dialogSelector);

  const setText = (root, selector, value, fallback = '—') => {
    const el = root.querySelector(selector);
    if (el) el.textContent = value || fallback;
  };

  const openRequest = (trigger) => {
    const dialog = getDialog();
    if (!(dialog instanceof HTMLDialogElement)) return;

    const data = trigger.dataset;
    dialog.dataset.productTitle = data.productTitle || '';
    dialog.dataset.variantTitle = data.variantTitle || '';
    dialog.dataset.sku = data.sku || '';
    dialog.dataset.price = data.price || '';
    dialog.dataset.variantId = data.variantId || '';
    dialog.dataset.productUrl = data.productUrl || window.location.href;

    setText(dialog, '[data-apk-summary-product]', data.productTitle, 'Prodotto');
    setText(dialog, '[data-apk-summary-variant]', data.variantTitle, '');
    setText(dialog, '[data-apk-summary-sku]', data.sku);
    setText(dialog, '[data-apk-summary-price]', data.price);

    if (!dialog.open) dialog.showModal();
    window.setTimeout(() => dialog.querySelector('input[name="contact[name]"]')?.focus(), 0);
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest?.(triggerSelector);
    if (trigger) {
      event.preventDefault();
      openRequest(trigger);
      return;
    }

    const close = event.target.closest?.('[data-apk-availability-close]');
    if (close) {
      event.preventDefault();
      getDialog()?.close();
    }
  });

  document.addEventListener('click', (event) => {
    const dialog = getDialog();
    if (!(dialog instanceof HTMLDialogElement) || !dialog.open || event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    const inside =
      event.clientX >= rect.left && event.clientX <= rect.right &&
      event.clientY >= rect.top && event.clientY <= rect.bottom;
    if (!inside) dialog.close();
  });

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || form.id !== 'ApkSinedAvailabilityForm') return;

    const dialog = getDialog();
    if (!(dialog instanceof HTMLDialogElement)) return;

    const message = form.querySelector('[data-apk-request-message]')?.value?.trim() || '';
    const lines = [
      'RICHIESTA DISPONIBILITÀ APOKTO',
      '',
      'Prodotto: ' + (dialog.dataset.productTitle || ''),
      'Variante: ' + (dialog.dataset.variantTitle || ''),
      'SKU: ' + (dialog.dataset.sku || ''),
      'Prezzo visualizzato: ' + (dialog.dataset.price || ''),
      'Variant ID: ' + (dialog.dataset.variantId || ''),
      'URL: ' + (dialog.dataset.productUrl || window.location.href),
      '',
      'Messaggio cliente: ' + (message || 'Nessun messaggio aggiuntivo.')
    ];

    const body = form.querySelector('[data-apk-request-body]');
    if (body) body.value = lines.join('\n');

    const subject = form.querySelector('[data-apk-request-subject]');
    if (subject) {
      const product = dialog.dataset.productTitle || 'prodotto';
      const variant = dialog.dataset.variantTitle || '';
      subject.value = 'Richiesta disponibilità - ' + product + (variant ? ' - ' + variant : '');
    }
  });

  const reopenSuccess = () => {
    const success = document.querySelector('[data-apk-request-success]');
    const dialog = getDialog();
    if (success && dialog instanceof HTMLDialogElement && !dialog.open) dialog.showModal();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reopenSuccess, { once: true });
  } else {
    reopenSuccess();
  }

  /*
   * PDP: il pulsante standard Add to cart e il trigger "Richiedi disponibilità"
   * sono entrambi presenti nel DOM. La regola è selezionata da data-apk-request-mode:
   * - sined-unavailable: CTA richiesta quando Shopify considera la variante non disponibile.
   * - novaterm-stock-zero: CTA richiesta quando l'inventario Shopify è tracciato e la quantità <= 0,
   *   anche se inventory policy CONTINUE lascerebbe la variante acquistabile.
   */
  const componentSelector = 'add-to-cart-component[data-apk-variants]';
  const variantsCache = new WeakMap();

  const readVariants = (component) => {
    const raw = component.dataset.apkVariants || '';
    const cached = variantsCache.get(component);
    if (cached && cached.raw === raw) return cached.list;
    let list = [];
    try {
      const parsed = JSON.parse(raw || '[]');
      if (Array.isArray(parsed)) list = parsed;
    } catch (error) {
      list = [];
    }
    variantsCache.set(component, { raw, list });
    return list;
  };

  const selectedVariantId = (component) => {
    const scope = component.closest('product-form-component') || document;
    const input = scope.querySelector('input[name="id"]');
    if (input && input.value) return String(input.value);
    const fromUrl = new URLSearchParams(window.location.search).get('variant');
    if (fromUrl) return String(fromUrl);
    return component.dataset.apkSelectedVariant || '';
  };

  const normalizePath = (value) => {
    const normalized = String(value || '/').replace(/\/+$/, '');
    return normalized || '/';
  };

  const isMainProductComponent = (component) => {
    const base = component.dataset.apkProductUrl || '';
    if (!base) return false;
    try {
      return normalizePath(new URL(base, window.location.origin).pathname) === normalizePath(window.location.pathname);
    } catch (error) {
      return false;
    }
  };

  const setDataIfChanged = (el, key, value) => {
    const next = value == null ? '' : String(value);
    if (el.dataset[key] !== next) el.dataset[key] = next;
  };

  const setDisabledIfChanged = (el, disabled) => {
    if (el && el.disabled !== disabled) el.disabled = disabled;
  };

  /*
   * Hardening dinamico del quantity selector principale.
   * Shopify può lasciare l'attributo disabled della variante precedente
   * durante un cambio esaurito -> disponibile. Riallineiamo solo il selector
   * della PDP principale, senza toccare cart, drawer o raccomandazioni.
   */
  const syncMainQuantity = (component, requestAvailability) => {
    if (!isMainProductComponent(component)) return;

    const sectionScope =
      component.closest('.shopify-section') ||
      component.closest('[id^="shopify-section-"]') ||
      document;

    const quantity =
      sectionScope.querySelector('quantity-selector-component[ref="quantitySelector"]') ||
      sectionScope.querySelector('quantity-selector-component');

    if (!quantity) return;

    const input =
      quantity.querySelector('input[ref="quantityInput"][name="quantity"]') ||
      quantity.querySelector('input[type="number"][name="quantity"]');
    const minus =
      quantity.querySelector('button[ref="minusButton"]') ||
      quantity.querySelector('button[name="minus"]');
    const plus =
      quantity.querySelector('button[ref="plusButton"]') ||
      quantity.querySelector('button[name="plus"]');

    if (!input) return;

    if (requestAvailability) {
      setDisabledIfChanged(input, true);
      setDisabledIfChanged(minus, true);
      setDisabledIfChanged(plus, true);
      return;
    }

    setDisabledIfChanged(input, false);

    const value = Number(input.value);
    const minRaw = input.dataset.min || input.min;
    const maxRaw = input.max;
    const min = Number(minRaw);
    const max = maxRaw === '' ? NaN : Number(maxRaw);

    const disableMinus =
      Number.isFinite(value) && Number.isFinite(min) ? value <= min : false;
    const disablePlus =
      Number.isFinite(value) && Number.isFinite(max) ? value >= max : false;

    setDisabledIfChanged(minus, disableMinus);
    setDisabledIfChanged(plus, disablePlus);
  };

  const syncComponent = (component) => {
    const variants = readVariants(component);
    if (!variants.length) return;

    const id = selectedVariantId(component);
    const variant = variants.find((item) => String(item.id) === id);
    if (!variant) return;

    const trigger = component.querySelector(triggerSelector);
    const main = component.querySelector('[ref="addToCartButton"]');
    if (!trigger || !main) return;

    setDataIfChanged(trigger, 'variantId', variant.id);
    setDataIfChanged(trigger, 'variantTitle', variant.title);
    setDataIfChanged(trigger, 'sku', variant.sku);
    setDataIfChanged(trigger, 'price', variant.price);
    const base = component.dataset.apkProductUrl || '';
    if (base) setDataIfChanged(trigger, 'productUrl', base + '?variant=' + variant.id);

    const mode = component.dataset.apkRequestMode || 'sined-unavailable';
    let requestAvailability = variant.available === false;

    if (mode === 'novaterm-stock-zero') {
      const quantity = Number(variant.inventoryQuantity);
      requestAvailability =
        variant.inventoryManaged === true &&
        Number.isFinite(quantity) &&
        quantity <= 0;
    }

    if (trigger.hidden === requestAvailability) trigger.hidden = !requestAvailability;
    if (main.hidden !== requestAvailability) main.hidden = requestAvailability;

    if (isMainProductComponent(component)) {
      syncMainQuantity(component, requestAvailability);

      const sticky = document.querySelector('sticky-add-to-cart');
      if (sticky && sticky.hidden !== requestAvailability) sticky.hidden = requestAvailability;
    }
  };

  let syncQueued = false;
  const syncAll = () => {
    syncQueued = false;
    document.querySelectorAll(componentSelector).forEach(syncComponent);
  };
  const scheduleSync = () => {
    if (syncQueued) return;
    syncQueued = true;
    window.requestAnimationFrame(syncAll);
  };
  const scheduleSyncBurst = () => {
    scheduleSync();
    [120, 400, 900].forEach((delay) => window.setTimeout(scheduleSync, delay));
  };

  const startSync = () => {
    syncAll();
    new MutationObserver(scheduleSync).observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['hidden', 'disabled']
    });
    const onPickerInteraction = (event) => {
      if (event.target.closest?.('variant-picker')) scheduleSyncBurst();
    };
    document.addEventListener('change', onPickerInteraction);
    document.addEventListener('click', onPickerInteraction);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startSync, { once: true });
  } else {
    startSync();
  }
})();
